import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
